import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import CustomModal from "../../../../Panel/Common/Components/Modal/CustomModal";
function Offers({ data, buyoffer, isApp }) {
  const [modal, setModal] = useState(false);
  const [loading, setloading] = useState(false);
  const HandlerBuy = () => {
    setloading(true);
    buyoffer({ offer_id: modal }).then(result => {
      setModal(false);
      setloading(false);
    });
  };

  return (
    <div className={!isApp && "row mt-4 "}>
      <div className="clup-card">
        <div className="titre">
          <i
            className="far fa-club"
            style={{ fontSize: "25px", marginLeft: "5px" }}
          />
          <h6 className={isApp && "border-bottom pb-2 mb-2 w-100"}>باشگاه نیکوتنی ها</h6>
        </div>
        <div className="row card-box">
          {data &&
            data.map((off, count) => {
              return <Cards key={count} setModal={setModal} off={off} />;
            })}
        </div>
        <CustomModal
          handleClose={() => {
            setModal(false);
          }}
          size={"sm"}
          header={"اطلاعات تخفیف"}
          show={modal}
        >
          <Modal
            offer={
              modal &&
              data.filter(off => {
                return off.id == modal;
              })[0]
            }
            HandlerBuy={HandlerBuy}
            loading={loading}
          />
        </CustomModal>
      </div>
    </div>
  );
}

export default Offers;

const Cards = ({ setModal, off }) => {
  const type = () => {
    switch (off.product_type) {
      case "all":
        return "تمامی خدمات نیکوتن";
      case "joinclass":
        return "ثبت نام در کلاس های نیکوتن";
      case "reserve":
        return "رزرواسیون";
    }
  };
  return (
    <div
      className="col-md-6 mt-2"
      onClick={() => {
        setModal(off.id);
      }}
      style={{ cursor: "pointer" }}
    >
      <div className="card clups_cards" style={{ maxHeight: "127px" }}>
        <div className="row mt-1">
          <div className="col-8  col-md-9 ">
            <div className="card-body">
              <div className="d-flex flex-column">
                <div className="d-flex">
                  <h6>{type()}</h6>
                </div>
                <div
                  className="d-flex justify-content-end mb-1"
                  style={{
                    paddingBottom: "8px",
                    borderBottom: "4px dotted #00000016",
                  }}
                >
                  <span style={{ color: "#BCBCBC" }}>امتیاز مورد نیاز :</span>
                  <span style={{ color: "#BCBCBC" }}>
                    {" "}
                    {off.clupneed.score} امتیاز
                  </span>
                </div>
                <div className="d-flex align-items-center">
                  <i
                    className="fas fa-grin-tongue-squint"
                    style={{ marginLeft: "5px", fontSize: "20px" }}
                  />
                  <span>{off.clupneed.text}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-4  col-md-3  d-flex justify-content-end">
            <img
              src={off.clupneed.logo}
              className="img-fluid rounded-start "
              alt="..."
              style={{ objectFit: "fill", height: "100%", maxHeight: "125px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const Modal = ({ offer, HandlerBuy, loading }) => {
  const { user, user_type } = useSelector(state => state);
  const type = () => {
    switch (offer.product_type) {
      case "all":
        return "تمامی خدمات نیکوتن";
      case "joinclass":
        return "ثبت نام در کلاس های نیکوتن";
      case "reserve":
        return "رزرواسیون";
    }
  };
  return (
    <div className="d-flex flex-column">
      <div>
        <img
          src={offer && offer.clupneed.image}
          alt=""
          width={"100%"}
          height={"150px"}
        />
      </div>
      <div
        className="mt-2 pb-1"
        style={{ borderBottom: "2px dashed #00000016" }}
      >
        <div className="d-flex align-items-end ">
          <div style={{ width: "30px", height: "30px", marginLeft: "5px" }}>
            <img
              src={offer && offer.clupneed.image}
              alt=""
              style={{ objectFit: "fill", width: "100%", height: "100%" }}
            />
          </div>
          <h6>{type()}</h6>
        </div>
        <div
          className="d-flex justify-content-end "
          style={{ fontSize: "8px" }}
        >
          <span>امتیاز مورد نیاز</span>
          <span>{offer && offer.clupneed.score}</span>
        </div>
      </div>
      <div className="p-1">
        <p>{offer && offer.description}</p>
      </div>
      <div className="d-flex justify-content-center mt-1">
        <button
          className="btn btn-danger w-100"
          onClick={() => {
            user_type
              ? HandlerBuy()
              : toast.error("لطفا ابتدا ثبت نام کنید یا وارد سایت شوید");
          }}
        >
          {loading ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : (
            "دریافت کد"
          )}
        </button>
      </div>
    </div>
  );
};
